// removed by extract-text-webpack-plugin
module.exports = {"menuText":"#fff","menuActiveText":"#fff","subMenuActiveText":"#fff","menuBg":"#0b2771","menuHover":"#0736cb","subMenuBg":"#041954","subMenuHover":"#0736cb","sideBarWidth":"210px","primaryFontColor":"#222","primaryColor":"#0736cb"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/index.scss
// module id = yh13
// module chunks = 27